const RegistryVendor = Object.freeze({
  acs: 'AZURE',
  docker: 'DOCKER',
  dockerHub: 'DOCKER_HUB',
  ecr: 'AMAZON',
  gcr: 'GOOGLE',
  other: 'OTHER',
  quay: 'QUAY',
});

export default RegistryVendor;
